export const fuctions = () => {
  const omitFields = (data, fieldsToRemove) =>
    Object.keys(data).reduce((acc, key) => {
      if (!fieldsToRemove.includes(key)) {
        acc[key] = data[key];
      }
      return acc;
    }, {});

  const formatDataUpdateProtocol = (data) =>
    omitFields(data, [
      'telephone',
      'client_id',
      'service_channel',
      'reason_id',
      'current_responsible',
      'current_status',
      'subreason_id'
    ]);

  const formatOptionsToSelect = (options) => {
    const formattedOptions = options.map((option) => {
      const options = {};
      options.label = option;
      options.value = option;
      return options;
    });

    return formattedOptions;
  };

  const dateRules = (validations) => {
    let rules = {
      required: validations ? 'Campo obrigatório' : false,
      pattern: {
        value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
        message: 'Data inválida! (dd/MM/aaaa)'
      }
    };
    return rules;
  };

  const initializeFromLocalStorage = () => {
    const valueRoute = localStorage.getItem('valueRoute');
    if (valueRoute) {
      const objectFromLocalStorage = JSON.parse(valueRoute);
      return {
        recordTypeId: objectFromLocalStorage.recordTypeId,
        returnPath: objectFromLocalStorage.returnPath
      };
    } else {
      return { recordTypeId: null, returnPath: '/admin/protocol' };
    }
  };

  return {
    formatDataUpdateProtocol,
    formatOptionsToSelect,
    dateRules,
    initializeFromLocalStorage,
    omitFields
  };
};
